// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import Close from "@guestsupply/XDL/Icons/Close";
import { xBaseTheme } from "@guestsupply/XDL/types";
import DrawerPresentationPropsDefault from "@insite/mobius/Drawer/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DrawerPresentationPropsDefault,
        cssOverrides: {
            ...DrawerPresentationPropsDefault.cssOverrides,
            titleButton: css``,
            headlineTypography: css`
                font-weight: bold;
                color: ${getColor("text.main")};
                text-transform: capitalize;
            `,
            scrim: css`
                ${({ persistentClosed, persisted }: any) =>
                    persisted && persistentClosed
                        ? `
                        background-color: rgba(0, 0, 0, 0);
                    `
                        : `
                        background-color: rgba(0, 0, 0, 0.2);
                    `}
            `,
        },
        headlineTypographyProps: {
            ...DrawerPresentationPropsDefault.headlineTypographyProps,
            size: 18,
            lineHeight: "22px",
        },
        closeButtonIconProps: {
            ...DrawerPresentationPropsDefault.closeButtonIconProps,
            src: Close,
            size: 14,
            css: css`
                margin-right: 7px;
            `,
        },
    },
} as xBaseTheme["drawer"];
